<template>
    <UContainer class="snap-x">
        <div class="">
            <slot></slot>        
        </div>
        <Footer></Footer>  
    </UContainer>   
</template>

<style>
html {
    scroll-behavior: smooth;
}
</style>